import { useReducer } from 'react'
import { toast } from 'react-toastify'
import { authenticationUser } from 'services/authenticationUser'
import { initialState } from '../utilities/initialValues'
import { videoCaptureReducer } from '../utilities/videoCaptureReducer'

interface ISubmit {
    resetFormData: () => void
    formData: IFormData
}

const useSubmitAuthentication = ({ resetFormData, formData }: ISubmit) => {
    const [state, dispatch] = useReducer(videoCaptureReducer, initialState)
    const handleFinalSubmit = async () => {
        const {
            nationalCode,
            phoneNumber,
            serialCode,
            nationalCardPhoto,
            photo,
            video,
        } = formData

        const finalFormData = new FormData()
        finalFormData.append('nationalCode', nationalCode)
        finalFormData.append('phoneNumber', phoneNumber)
        finalFormData.append('serialCode', serialCode)
        if (nationalCardPhoto)
            finalFormData.append('nationalCardPhoto', nationalCardPhoto)
        if (photo) finalFormData.append('photo', photo, 'photo.png')
        if (video) finalFormData.append('video', video, 'video.webm')

        try {
            dispatch({ type: 'SET_IS_UPLOADING', payload: true })
            const response = await authenticationUser(finalFormData)

            if (response.status === 200) {
                toast.success('احراز هویت با موفقیت انجام شد')
                resetFormData()
            } else {
                toast.error('خطا در انجام احراز هویت. لطفا دوباره تلاش کنید')
            }
        } catch (error) {
            console.error('Error submitting data:', error)
            toast.error('خطا در انجام احراز هویت. لطفا دوباره تلاش کنید')
        } finally {
            dispatch({ type: 'SET_IS_UPLOADING', payload: false })
        }
    }
    return { handleFinalSubmit, isUploading: state.isUploading }
}

export default useSubmitAuthentication
